import { LimitedCompanyScreen } from './LimitedCompanyScreen';

/** Angular LimitedcompanyComponent: Limited Company (UK-GAAP), `/home/settings/limited-company`. */
export function Limitedcompany() {
  return (
    <LimitedCompanyScreen
      settingsKey="limited-uk-gaap"
      padded
      tooltip="Configure default report and accounting policy headings for all Limited Companies. Narrative note bodies and wording are customized per client under Report Settings."
    />
  );
}
